import {createFeatureSelector, createSelector} from "@ngrx/store";
import {SelectorUtil} from "@app-web-central/web/shared/utils";
import {recipientsFeatureKey, RecipientsState} from "./recipients.reducer";

export const getRecipientsState = createFeatureSelector<RecipientsState>(recipientsFeatureKey);

export const getRecipients = createSelector(getRecipientsState, (state) => state.data);
export const getRecipientsLoading = createSelector(getRecipientsState, SelectorUtil.isLoading);
